var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1953_5787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#800020"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 52C48 53.1 47.1 54 46 54H18C16.9 54 16 53.1 16 52C16 50.9 16.9 50 18 50H46C47.1 50 48 50.9 48 52Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36 45C36 46.7 34.7 48 33 48H31C29.3 48 28 46.7 28 45V35C28 33.3 29.3 32 31 32H33C34.7 32 36 33.3 36 35V45Z",
    fill: "#D8B400"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 34C39.9 34 39 33.1 39 32C39 30.9 39.9 30 41 30C44.2 30 48 24.5 48 21.1C48 18.4 48 18 44 18H20C16 18 16 18.3 16 21.1C16 24.5 19.8 30 23 30C24.1 30 25 30.9 25 32C25 33.1 24.1 34 23 34C17.4 34 12 26.6 12 21.1C12 14.6 15.8 14 20 14H44C48.2 14 52 14.5 52 21.1C52 26.6 46.6 34 41 34Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41 32C39.9 32 39 31.1 39 30C39 28.9 39.9 28 41 28C44.2 28 48 22.5 48 19.1C48 16.4 48 16 44 16H20C16 16 16 16.3 16 19.1C16 22.5 19.8 28 23 28C24.1 28 25 28.9 25 30C25 31.1 24.1 32 23 32C17.4 32 12 24.6 12 19.1C12 12.6 15.8 12 20 12H44C48.2 12 52 12.5 52 19.1C52 24.6 46.6 32 41 32Z",
    fill: "#D8B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12C18.6 31.9 26.4 36 32 36C37.6 36 45.3 31.9 46 12H18Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7008 50.3C42.5008 46.7 37.7008 44 32.0008 44C26.3008 44 21.5008 46.7 20.3008 50.3H43.7008Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 50C48 51.1 47.1 52 46 52H18C16.9 52 16 51.1 16 50C16 48.9 16.9 48 18 48H46C47.1 48 48 48.9 48 50Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 42C38 43.1 37.1 44 36 44H28C26.9 44 26 43.1 26 42C26 40.9 26.9 40 28 40H36C37.1 40 38 40.9 38 42Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38 40C38 41.1 37.1 42 36 42H28C26.9 42 26 41.1 26 40C26 38.9 26.9 38 28 38H36C37.1 38 38 38.9 38 40Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 16C48 17.1 47.1 18 46 18H18C16.9 18 16 17.1 16 16C16 14.9 16.9 14 18 14H46C47.1 14 48 14.9 48 16Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48 14C48 15.1 47.1 16 46 16H18C16.9 16 16 15.1 16 14C16 12.9 16.9 12 18 12H46C47.1 12 48 12.9 48 14Z",
    fill: "#FFD700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1953_5787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit);
export default __webpack_public_path__ + "static/media/benefit.8ac0d4073b8a7335ab87ac8784c841eb.svg";
export { ForwardRef as ReactComponent };